// extracted by mini-css-extract-plugin
module.exports = {"error":"U-z5t","proposed":"XQiJZ"};